/**
 * Mobile Mega Menu Component - Mikazo
 * Provides accordion dropdown behavior for mobile mega navigation
 */
class MobileMegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordionMode = this.dataset.accordionMode || 'multi';
    this.initToggles();
  }

  initToggles() {
    // Level 1 toggles
    const level1Toggles = this.querySelectorAll('.mobile-mega-menu__toggle');
    level1Toggles.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleLevel1(button);
      });
    });

    // Level 1 links with '#' href: allow clicking to toggle
    const level1Links = this.querySelectorAll('.mobile-mega-menu__link[href="#"], .mobile-mega-menu__link[href=""]');
    level1Links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const item = link.closest('.mobile-mega-menu__item');
        const toggle = item ? item.querySelector('.mobile-mega-menu__toggle') : null;
        if (toggle) this.toggleLevel1(toggle);
      });
    });

    // Level 2 toggles
    const level2Toggles = this.querySelectorAll('.mobile-mega-menu__sub-toggle');
    level2Toggles.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleLevel2(button);
      });
    });

    // Level 2 links with '#' href
    const level2Links = this.querySelectorAll('.mobile-mega-menu__sub-link[href="#"], .mobile-mega-menu__sub-link[href=""]');
    level2Links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const subItem = link.closest('.mobile-mega-menu__sub-item');
        const toggle = subItem ? subItem.querySelector('.mobile-mega-menu__sub-toggle') : null;
        if (toggle) this.toggleLevel2(toggle);
      });
    });
  }

  toggleLevel1(toggleBtn) {
    const item = toggleBtn.closest('.mobile-mega-menu__item');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');

    if (this.accordionMode === 'single' && !isOpen) {
      this.querySelectorAll('.mobile-mega-menu__item.is-open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const siblingToggle = openItem.querySelector('.mobile-mega-menu__toggle');
          if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (isOpen) {
      item.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
  }

  toggleLevel2(toggleBtn) {
    const subItem = toggleBtn.closest('.mobile-mega-menu__sub-item');
    if (!subItem) return;

    const isOpen = subItem.classList.contains('is-open');

    if (isOpen) {
      subItem.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    } else {
      subItem.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('mobile-mega-menu')) {
  customElements.define('mobile-mega-menu', MobileMegaMenu);
}
